import React, {
    useContext,
    useEffect,
    useState
} from 'react';
import Table from "./Table";
import ChartContext from "../contexts/ChartContext";
import WaitListToggle from "../contexts/WaitListToggle";
import WaitList from "./WaitList";
import CopierContext from "../contexts/CopierContext";
import SearchContext from "../contexts/SearchContext";
import VersionContext from "../contexts/VersionContext";
import InfoContext from "../contexts/InfoContext";
import { getAppVersion } from "../utils/lamba-api";
import { close_loader } from "../utils/loader-utils";
import ErrorContext from "../contexts/ErrorContext";
import Notification from "./Notification";
import EditContext from "../contexts/EditContext";
import Edit from "./Edit";
import BruceModeContext from '../contexts/BruceModeContext';

const Chart = () => {

    const [chart,] = useContext(ChartContext);
    const [waitList,] = useContext(WaitListToggle);
    const [copier, setCopier] = useContext(CopierContext);
    const [info, setInfo] = useContext(InfoContext);
    const [version] = useContext(VersionContext);
    const [error, setError] = useContext(ErrorContext);
    const [serverVersion, setServerVersion] = useState("");
    const [edit, setEdit] = useContext(EditContext);
    const [editData, setEditData] = useState(null)
    const [,] = useContext(SearchContext);
    const [trigger, setTrigger] = useState(false);
    const [bM, setBM] = useContext(BruceModeContext);

    // useEffect(() => {
    //     setTimeout(() => {
    //         let els = document.getElementsByClassName("table");
    //         Array.from(els).forEach(e => {
    //             if (!(e.id.includes("table"))) {
    //                 e.style.backgroundColor = "#721e15"
    //             }
    //         })
    //     }, 500)
    // }, [trigger, chart])

    useEffect(() => {
        // loop through each table per seating

        // seating 1
        // console.log(chart?.seatingOne);
        if (!chart) {
            return
        }
        let seatingOneDoubles = [];
        for (let i = 0; i < chart.seatingOne.length; i++) {
            let theTable = chart.seatingOne[i];

            for (let x = 0; x < theTable.table.length; x++) {
                let thisTableNumber = theTable.table[x];
                
                for (let y = 0; y < chart.seatingOne.length; y++) {
                    let theTableCompared = chart.seatingOne[y];
                    if (theTableCompared == theTable) {
                        // do nothing
                    } else {
                        for (let w = 0; w < theTableCompared.table.length; w++) {
                            let thisTableNumberCompared = theTableCompared.table[w];
                            if (thisTableNumberCompared === thisTableNumber) {
                                seatingOneDoubles.push(theTableCompared);
                                seatingOneDoubles.push(theTable)
                            }
                        }
                    }
                }
                // loop through each table again except the table it's on
            }
        }
        // console.log("Seating One Doubles");
        // console.log(seatingOneDoubles);
        let uniqueOneDoubles = [...new Set(seatingOneDoubles)]
        for (let i = 0; i < uniqueOneDoubles.length; i++) {
            uniqueOneDoubles[i].double = true;
        }
        let seatingTwoDoubles = [];
        for (let i = 0; i < chart.seatingTwo.length; i++) {
            let theTable = chart.seatingTwo[i];

            for (let x = 0; x < theTable.table.length; x++) {
                let thisTableNumber = theTable.table[x];
                
                for (let y = 0; y < chart.seatingTwo.length; y++) {
                    let theTableCompared = chart.seatingTwo[y];
                    if (theTableCompared == theTable) {
                        // do nothing
                    } else {
                        for (let w = 0; w < theTableCompared.table.length; w++) {
                            let thisTableNumberCompared = theTableCompared.table[w];
                            if (thisTableNumberCompared === thisTableNumber) {
                                seatingTwoDoubles.push(theTableCompared);
                                seatingTwoDoubles.push(theTable)
                            }
                        }
                    }
                }
                // loop through each table again except the table it's on
            }
        }

        // console.log("Seating Two Doubles")
        // console.log(seatingTwoDoubles)
        let uniqueTwoDoubles = [...new Set(seatingTwoDoubles)];
        for (let i = 0; i < uniqueTwoDoubles.length; i++) {
            uniqueTwoDoubles[i].double = true;
        }
        // console.log(uniqueTwoDoubles)

    }, [chart])

    useEffect(() => {
        const getServerVersion = async () => {
            return await getAppVersion();
        }
        if (info) {
            let value = null;
            getServerVersion().then(r => {
                value = r.data.body.response
                setServerVersion(value);

                setError({ notification: true, error: false })
                close_loader();
            })
                .catch(er => {
                    setError({ notification: true, error: true, message: "Unknown Error: Check Logs" })
                });
        }
    }, [info])

    return (<div id="chart-container" style={bM.isBruce ? {backgroundColor: 'gray'} : {}} onClick={(e) => e.stopPropagation()}>
        <div className="seating-container">
            {chart !== null && chart?.seatingOne ? chart.seatingOne.map((e, i) => {
                return (<Table originalTables={e.table} data={e} key={`Blueberry-${i}`} seating="1" setEditData={setEditData} />)
            }) : <></>}
        </div>
        <div className="seating-container">
            {chart !== null && chart?.seatingTwo ? chart.seatingTwo.map((e, i) => {
                return (<Table originalTables={e.table} data={e} key={`Snozzberry-${i}`} seating="2" setEditData={setEditData} />)
            }) : <></>}
        </div>
        {waitList ? <WaitList /> : <></>}
        {copier.active ? (<div id="number-box" onClick={(e) => e.stopPropagation()}>
            <textarea value={copier.data} onChange={(e) => {
            }} onClick={(e) => e.stopPropagation()} />
            <button onClick={() => setCopier({ active: false })}>CLOSE</button>
        </div>) : null}
        {
            info ? <div id="version-box" onClick={(e) => e.stopPropagation()}>
                <span>{`Your app version: ${version}`}</span>
                <span>{`Most recent app version: ${serverVersion}`}</span>
                <button onClick={() => setInfo(false)}>CLOSE</button>
            </div> : null
        }
        {
            edit ? <Edit data={editData} thisEdit={setEdit} seating={editData.seating} /> : <></>
        }
        {
            error.notification ? <Notification error={error.error} message={error.message} /> : null
        }


    </div>
    )
};

export default Chart;
